<div [fxShow]="!selectedStyleTemplate" class="w-100" fxLayout="row wrap" fxLayoutAlign="center center">
  <mat-form-field fxFlex="100">
    <input matInput type="text"
      [formControl]="searchField" 
      (keyup)="doFilter($event.target.value)"
      (keyup.esc)="$event.target.value=''; doFilter('')"
      placeholder="Filter style templates">
  </mat-form-field>

  <div fxFlex="5" fxLayout="column" fxLayoutAlign="center center">
    <button mat-icon-button color="accent" (click)="scrollLeft()">
      <mat-icon>chevron_left</mat-icon>
    </button>
  </div>
  <div #templatesContainer fxFlex="90" class="templates-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <ng-container *ngFor="let styleTemplate of filteredStyleTemplates">
      <div class="image-container" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" (click)="selectTemplate(styleTemplate)">
        <img  matTooltip="{{ styleTemplate?.name }}" *ngIf="styleTemplate?.thumbnailUrl" [src]="styleTemplate.thumbnailUrl" class="thumbnail">
        <div  matTooltip="{{ styleTemplate?.name }}" *ngIf="!styleTemplate?.thumbnailUrl" class="no-thumbnail banner-incomplete"></div>
        <div class="overlay-icon" fxLayout="row" fxLayoutAlign="end center">
          <mat-icon class="home-icon" *ngIf="styleTemplate.homeId" matTooltip="Home Template" color="basic">home</mat-icon>
          <mat-icon class="tag-icon" *ngIf="styleTemplate.tagId" [matTooltip]="'Tag Template: ' + styleTemplate?.tag?.name" color="basic">label</mat-icon>
          <mat-icon class="global-icon" *ngIf="styleTemplate?.homeId === null && styleTemplate?.tagId === null" matTooltip="Global Template" color="basic">public</mat-icon>
        </div>
        <div matTooltip="{{ styleTemplate?.name }}"
          class="styleTemplateName"
          [innerHtml]="styleTemplate?.name | highlight: searchField?.value">
        </div>
      </div>
    </ng-container>
  </div>
  <div fxFlex="5" fxLayout="column" fxLayoutAlign="center center">
    <button mat-icon-button color="accent" (click)="scrollRight()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
<div [fxShow]="selectedStyleTemplate" class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <div>
    <img class="static-thumbnail" matTooltip="{{ selectedStyleTemplate?.name }}" *ngIf="selectedStyleTemplate?.thumbnailUrl" [src]="selectedStyleTemplate.thumbnailUrl">
    <div class="static-thumbnail banner-incomplete" matTooltip="{{ selectedStyleTemplate?.name }}" *ngIf="!selectedStyleTemplate?.thumbnailUrl"></div>
  </div>
  <div fxLayout="column" fxLayoutAlign="start start">
    <div fxFlex="70" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
      <ng-container *ngFor="let style of selectedStyleTemplate?.styles">
        <img *ngIf="style?.thumbnailUrl" [src]="style.thumbnailUrl" class="style-thumbnail" matTooltip="{{ style?.name }}">
      </ng-container>
    </div>
    <div fxFlex="30" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <span>{{ selectedStyleTemplate?.name }}</span>
      <div fxLayout="row" fxLayoutAlign="start center">
        <button class="mini-icon" mat-icon-button color="basic" (click)="clearTemplate()">
          <mat-icon>clear</mat-icon>
        </button>
        <a *ngIf="isAdmin || isSituUser" target="_blank" class="mini-icon" mat-icon-button color="accent" [routerLink]="['/admin/style-template/' + selectedStyleTemplate?.id]">
          <mat-icon>edit</mat-icon>
        </a>
      </div>
    </div>
  </div>
</div>